import {
  AddOtherChargesAPIResponse,
  BaseReducerState,
  Bill,
  EditBillAPIResponse,
} from '../../../services'
import { ActionTypes } from '../actions'

export type EditBillState = BaseReducerState & {
  data: Bill
  code?: number
}

const editBillInitialState: EditBillState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const editBill = (
  state: EditBillState = editBillInitialState,
  action: { type: string; res: any }
): EditBillState => {
  switch (action.type) {
    case `${ActionTypes.EDIT_BILL}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.EDIT_BILL}_SUCCESS`: {
      const { success, data, message, code } = <EditBillAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        code,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.EDIT_BILL}_FAILURE`:
      const res = <EditBillAPIResponse>action.res
      const { message, code } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
        code,
      }

    case `${ActionTypes.EDIT_BILL}_RESET`:
      return {
        ...state,
        loading: false,
        success: false,
        message: null,
        data: null,
        error: null,
        code: undefined,
      }
  }
  return state
}
